import script from "./VatExceptionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./VatExceptionsView.vue?vue&type=script&setup=true&lang=js"

import "./VatExceptionsView.vue?vue&type=style&index=0&id=20c6e19a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c6e19a"]])

export default __exports__